import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useAuthSession } from '@/common/hooks/useAuthSession';
import { fetchAccessToken } from '@/common/utils/fetchAccessToken';
import { getEnv } from '@/common/utils/getEnv';
import { getJwtUserContext } from '@/common/utils/getJwtUserContext';

export function useDatadogUserTracking() {
  const { isAuthenticated } = useAuthSession();

  useEffect(() => {
    if (isAuthenticated) {
      fetchAccessToken()
        .then((accessToken) => {
          const payload = getJwtUserContext(accessToken);
          datadogRum.setUser({
            id: payload.userId,
            org_id: payload.organizationId,
            org_name: payload.organizationName,
          });
          datadogRum.setGlobalContext({
            org_id: payload.organizationId,
            org_name: payload.organizationName,
            namespace: getEnv().namespace,
          });
        })
        .catch(() => {});
    } else {
      datadogRum.clearUser();
    }
  }, [isAuthenticated]);
}
